import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

export const expertDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: { main: '#6FA8DC' },
    secondary: { main: '#90CAF9' },
    background: {
      default: '#1A1A2E',
      paper: '#16213E',
    },
    navigation: {
      background: '#0F1626',
      color: '#CCCCCC',
      indicator: '#6FA8DC',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#1B2A4A',
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#1A1A2E !important',
        },
        '#root': {
          backgroundColor: '#1A1A2E',
        },
        '@keyframes pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.4 },
        },
        '.qa-template-row:focus-visible': {
          boxShadow: '0 0 0 2px #6FA8DC inset',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    BackstageContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1A2E',
        },
      },
    },
    BackstagePage: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1A2E',
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundColor: '#0F1626',
          color: '#FFFFFF',
        },
      },
    },
    BackstageItemCardHeader: {
      styleOverrides: {
        root: {
          backgroundColor: '#0F1626',
          color: '#FFFFFF',
        },
      },
    },
    BackstageHeaderTabs: {
      styleOverrides: {
        tabsWrapper: {
          backgroundColor: '#0F1626',
        },
      },
    },
    BackstageTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    CatalogReactUserListPicker: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.MuiGrid-container': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#16213E',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0F1626',
        },
      },
    },
  },
  pageTheme: {
    home: genPageTheme({ colors: ['#0F1626', '#1B2A4A'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#0F1626', '#1B3A5C'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#0F1626', '#2A4A6A'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#0F1626', '#1B2A4A'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#0F1626', '#1B3A5C'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#0F1626', '#2A4A6A'],
      shape: shapes.round,
    }),
    other: genPageTheme({
      colors: ['#0F1626', '#1B2A4A'],
      shape: shapes.wave,
    }),
    app: genPageTheme({ colors: ['#0F1626', '#1B2A4A'], shape: shapes.wave }),
  },
  defaultPageTheme: 'home',
});
